var AddChildrenMap = function (key, gameObject) {
    this.childrenMap[key] = gameObject;
    return this;
}

export default AddChildrenMap;